// Site settings: public read + admin write. Footer and other site-wide content live here.
import axios from "axios";
import { getAdminPassword } from "./adminApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchSiteSettings() {
  try {
    const res = await axios.get(`${API}/site-settings`);
    return res.data || null;
  } catch {
    return null;
  }
}

export async function adminGetSiteSettings() {
  const pwd = getAdminPassword();
  const res = await axios.get(`${API}/admin/site-settings`, {
    headers: pwd ? { "X-Admin-Password": pwd } : {},
  });
  return res.data;
}

export async function adminUpdateSiteSettings(payload) {
  const pwd = getAdminPassword();
  const res = await axios.put(`${API}/admin/site-settings`, payload, {
    headers: pwd ? { "X-Admin-Password": pwd } : {},
  });
  return res.data;
}
